import classNames from 'classnames';
import * as React from 'react';
import { Icon } from '../Icon/Icon.js';

/* eslint-disable */
var CallingTextContainer = props => {
  var {
    callingTextRef,
    children,
    handleBlur,
    handleOnClick,
    handleKeyPress,
    icon = false,
    id,
    text,
    visible
  } = props;
  var containerClassName = classNames('tooltip', {
    'tooltip--visible': visible,
    'tooltip--withicon': icon
  });
  var labelClassName = classNames('tooltip__label', {
    'tooltip__label--highlight': visible
  });
  return /*#__PURE__*/React.createElement("span", {
    className: containerClassName,
    tabIndex: 0,
    id: "".concat(id, "-tooltip"),
    ref: callingTextRef,
    "aria-expanded": visible,
    onClick: handleOnClick,
    onBlur: handleBlur,
    onKeyDown: handleKeyPress,
    role: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: labelClassName
  }, text), icon && /*#__PURE__*/React.createElement(Icon, {
    className: "tooltip__icon",
    symbol: "controlInfo24",
    type: "svginline"
  }), children);
};
var CallingTextContainer$1 = CallingTextContainer;

export { CallingTextContainer$1 as default };
